import React, { Component, useState, useEffect, useContext } from 'react'
import { useLocation, useNavigate, Link } from 'react-router-dom';
import Header from '../components/Header'
import Footer from '../components/Footer'
import IndicatorCompare from '../dashboard_components/IndicatorCompare'
import AreaCompare from '../dashboard_components/AreaCompare'
import FYCompare from '../dashboard_components/FYCompare'
import IndicatorCompareLineChart from '../dashboard_components/IndicatorCompareLineChart'
import IndicatorCompareBarChart from '../dashboard_components/IndicatorCompareBarChart'
import AreaCompareLineChart from '../dashboard_components/AreaCompareLineChart'
import FYCompareLineChart from '../dashboard_components/FYCompareLineChart'
import { fetchDataCompare, getIndicatorArray } from '../util.js'
import useAxios from './useAxios';
import { SkeletonIndiComp, SkeletonCompare } from "./SkeletonCard";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import AuthContext from '../context/AuthContext';
import * as htmlToImage from 'html-to-image';
import jsPDF from 'jspdf';

export default function Compare() {

    const [level, setLevel] = useState("state");
    const [barChartData, setbarChartData] = useState([]);
    const [indicator, setIndicator] = useState([5]);
    const [fyear, setFyear] = useState([3]);
    const [month, setMonth] = useState(13);
    const [state, setState] = useState([1]);
    const [district, setDistrict] = useState([774]);
    const [area, setArea] = useState([1]);
    const [areaType, setAreaType] = useState('State');
    const [indicatorType, setIndicatorType] = useState('positive');
    const [indicatorCategory, setIndicatorCategory] = useState(1);
    const [areaDetails, setAreaDetails] = useState([]);
    const [stateDropdown, setStateDropdown] = useState([]);
    const [districtDropdown, setDistrictDropdown] = useState([]);
    const [fyDropdown, setFYDropdown] = useState([]);
    const [monthDropdown, setMonthDropdown] = useState([]);
    const [indicatorDropdown, setIndicatorDropdown] = useState([]);
    const location = useLocation();
    const [lineChartData, setLineChartData] = useState([]);
    const [tableData, setTableData] = useState([]);
    const [qualityData, setQualityData] = useState([]);
    const [toggleState, setToggleState] = useState(true);

    const [results, setResults] = useState([]);
    const [status, setStatus] = useState("indicator")
    const [isSelected, setIsSelected] = useState(true);
    const [toggleValue, setToggleValue] = useState('percent');
    const [found, setFound] = useState(true);
    let { user } = useContext(AuthContext);
    let areaStateId = user.state;
    const api = useAxios();
    let SkeletonScreen;

    const onChangeValue = async (e) => {
        setIsSelected(false);
        const statusVal = e.target.value;

        setFyear([3]);
        setMonth([13]);
        setArea([1]);
        setIndicator([5]);
        setState([1]);
        setDistrict([774]);
        setAreaType('State');
        let fyReset = [3];
        let areaReset = [1];
        let indicatorReset = [5];
        let monthReset = 13;
        let areaTypeReset = 'State';
        let indicator_cat = 1;
        setStatus(statusVal);

        await fetchDataCompare(fyReset, monthReset, areaReset, indicatorReset, areaTypeReset, indicator_cat, statusVal, setbarChartData, setLineChartData, setTableData, setQualityData, api);
        setIsSelected(true);
    }

    useEffect(() => {
        setIsSelected(false);
        async function getInitialData() {
            const [response1, response2, response3, response4] = await Promise.all([
                api.get(`/ina_area/${areaStateId}`),
                api.get('/fy'),
                api.get('/month'),
                api.get('/indicators')
            ]);

            let areaData = response1.data.filter(f => (f.area_level != 5));
            setAreaDetails(areaData);
            let stateData = areaData.filter(f => (f.area_type === 'State'));
            let districtData = areaData.filter(f => (f.area_type === 'District') & (f.area_id != 774));
            setStateDropdown(stateData);
            setDistrictDropdown(districtData);


            let fyData = response2.data.filter(m => (m.fy_id < 5));
            setFYDropdown(fyData);

            let monthData = response3.data.filter(m => (m.month_id < 14));
            setMonthDropdown(monthData);

            let indicatorData = response4.data.filter(i => (i.indicator_id < 37 && i.indicator_id != 29));
            setIndicatorDropdown(indicatorData);

            await fetchDataCompare(fyear, month, area, indicator, areaType, indicatorCategory, status, setbarChartData, setLineChartData, setTableData, setQualityData, api);
            setIsSelected(true);
        }
        getInitialData();

    }, []);

    const ToggleButtonChange = async (event, newAlignment) => {
        setIsSelected(false);
        setToggleValue(newAlignment);
        let indicator_values = indicator;
        if (newAlignment === 'count') {
            let indiArray = getIndicatorArray(indicatorDropdown, indicator_values, newAlignment);
            if (indiArray.length === 0) {
                setFound(false);
            }
            else {
                let indicatorSelected = indiArray.join(',');
                setFound(true);
                await fetchDataCompare(fyear, month, area, indicatorSelected, areaType, indicatorCategory, status, setbarChartData, setLineChartData, setTableData, setQualityData, api);
            }

        } else {
            let indiArray = getIndicatorArray(indicatorDropdown, indicator_values, newAlignment);
            if (indiArray.length === 0) {
                setFound(false);
            }
            else {
                let indicatorSelected = indiArray.join(',');
                setFound(true);
                await fetchDataCompare(fyear, month, area, indicatorSelected, areaType, indicatorCategory, status, setbarChartData, setLineChartData, setTableData, setQualityData, api);
            }

        }
        setIsSelected(true);
    };

    const theme = createTheme({
        components: {
            MuiToggleButton: {
                styleOverrides: {
                    root: {
                        border: `1px solid #000`,
                        color: '#000',
                        fontWeight: 'bold',
                    },
                },
            },
        },
    });

    let ToggleButtonSwitch = <ThemeProvider theme={theme}>
        <ToggleButtonGroup
            color="info"
            value={toggleValue}
            fullWidth={true}
            exclusive
            onChange={ToggleButtonChange}
            aria-label="Platform"
            variant="contained"
        >
            <ToggleButton value="percent">Percent</ToggleButton>
            <ToggleButton value="count">Count</ToggleButton>
        </ToggleButtonGroup>
    </ThemeProvider>


  if (status === 'fy' || status === 'area') {
    SkeletonScreen = <SkeletonCompare />;
  } else {
    SkeletonScreen = <SkeletonIndiComp />;
  }

  const downloadAll = async () => {
    let lineChartURL, barChartURL, imageURLs;
    if (status === 'indicator') {
      if (fyear != 'All' && area < 441) {
        lineChartURL = await htmlToImage.toPng(document.getElementById('indicatorLineChart'), {
          quality: 1,
          height: document.getElementById('indicatorLineChart').offsetHeight + 150,
          width: document.getElementById('indicatorLineChart').offsetWidth + 150,
          canvasWidth: 1920,
          canvasHeight: 1080,
        });
        barChartURL = await htmlToImage.toPng(document.getElementById('indicatorBarChart'), {
          quality: 1,
          height: document.getElementById('indicatorBarChart').offsetHeight + 150,
          width: document.getElementById('indicatorBarChart').offsetWidth + 150,
          canvasWidth: 1920,
          canvasHeight: 1080,
        });
        imageURLs = [lineChartURL, barChartURL];
      } else {
        lineChartURL = await htmlToImage.toPng(document.getElementById('indicatorLineChart'), {
          quality: 1,
          height: document.getElementById('indicatorLineChart').offsetHeight + 150,
          width: document.getElementById('indicatorLineChart').offsetWidth + 150,
          canvasWidth: 1920,
          canvasHeight: 1080,
        });
        imageURLs = [lineChartURL];
      }
    } else if (status === 'fy') {
      lineChartURL = await htmlToImage.toPng(document.getElementById('fyLineChart'), {
        quality: 1,
        height: document.getElementById('fyLineChart').offsetHeight + 150,
        width: document.getElementById('fyLineChart').offsetWidth + 150,
        canvasWidth: 1920,
        canvasHeight: 1080,
      });
      imageURLs = [lineChartURL];
    } else {
      lineChartURL = await htmlToImage.toPng(document.getElementById('areaLineChart'), {
        quality: 1,
        height: document.getElementById('areaLineChart').offsetHeight + 150,
        width: document.getElementById('areaLineChart').offsetWidth + 150,
        canvasWidth: 1920,
        canvasHeight: 1080,
      });
      imageURLs = [lineChartURL];
    }

    const pdf = new jsPDF('l');
    let width = pdf.internal.pageSize.getWidth();
    let height = pdf.internal.pageSize.getHeight();

    pdf.setFontSize(30);
    pdf.setFont(undefined, 'bold');
    pdf.text(`India HMIS - Data Analysis and Visualization`, width / 2 / 4, height / 8);
    pdf.setFontSize(15);
    pdf.text(`(Compare Page)`, width / 2, height / 6, { align: 'center' });

    pdf.addImage('/assets/img/pregnancy.png', 'PNG', 30, height / 3, 50, 50);
    pdf.addImage('/assets/img/deliveries.png', 'PNG', 95, height / 3, 50, 50);
    pdf.addImage('/assets/img/child_immunisation.png', 'PNG', 160, height / 3, 50, 50);
    pdf.addImage('/assets/img/child_disease.png', 'PNG', 225, height / 3, 50, 50);

    pdf.setFontSize(10);
    pdf.text(`Developed in Collaboration with`, width / 1.8, height - 20);
    pdf.addImage('/assets/img/nhm_mh_logo.png', 'PNG', 230, height - 25, 10, 10);
    pdf.addImage('/assets/img/iitb.png', 'PNG', 245, height - 25, 10, 10);
    pdf.addImage('/assets/img/ctara.png', 'PNG', 260, height - 23, 20, 7);
    pdf.addPage();

    imageURLs.forEach((url, index) => {
      let link = document.createElement('a');
      link.download = 'imageNameJpeg';

      let img = new Image();
      img.src = url;
      img.onload = function () {
        pdf.addImage(url, 'PNG', 0, 0, width - 10, height - 10);
        pdf.addPage();
        if (index === imageURLs.length - 1) {
          pdf.deletePage(pdf.internal.getNumberOfPages());
          pdf.save('ComparePage.pdf');
        }
      };
    });
  };

    return (
        <React.Fragment>
            <Header />

            <div class="container-fluid">
                <div class="row">
                    {/* <SideMenu /> */}
                    <main class="col hmis-dashboard-main md:mx-2.5">
                        <div class="container-2xl m-0">
                            <div class="flex md:flex-wrap flex-wrap md:mb-3 md:px-1">
                                <div class="flex w-full md:w-3/4">
                                    <h2 class="text-3xl font-bold text-black md:text-2xl lg:text-3xl">HMIS Dashboard <span class="hmis-beta">Beta</span></h2>
                                </div>
                                <div class="flex flex-row w-full md:w-1/4 justify-center">
                                    {/* <Link to="#">
                                        <button className="bg-cyan-900 hover:bg-gray-900 text-white font-bold text-md mb-1 py-2 px-4 mt-1 rounded-full">Cumulative</button>
                                    </Link> */}
                                    <button type='button' className='download-button my-1 px-4 py-2' onClick={downloadAll}>
                                        <svg
                                        xmlns='http://www.w3.org/2000/svg'
                                        fill='#164e63'
                                        className='inline pb-1'
                                        height='20'
                                        width='20'
                                        viewBox='0 0 512 512'
                                        >
                                        <path d='M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32V274.7l-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7V32zM64 352c-35.3 0-64 28.7-64 64v32c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V416c0-35.3-28.7-64-64-64H346.5l-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352H64zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z' />
                                        </svg>{' '}
                                        Download All
                                    </button>
                                    <Link to="/dashboard">
                                        <button className="bg-cyan-900 hover:bg-gray-900 text-white font-bold text-md mb-1 ml-3 py-2 px-4 mt-1 rounded-full">Back</button>
                                    </Link>
                                </div>
                            </div>

                            <div class="flex flex-col flex-wrap md:flex-row mx-3" onChange={onChangeValue}>
                                <div class="flex w-full md:w-1/2 lg:w-1/3">
                                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio1" value="indicator" checked={status === "indicator"} />
                                    <label class="ml-2 text-base font-medium text-black" for="inlineRadio1">Indicator wise Comparison</label>
                                </div>
                                <div class="flex w-full md:w-1/2 lg:w-1/3">
                                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio2" value="fy" checked={status === "fy"} />
                                    <label class="ml-2 text-base font-medium text-black" for="inlineRadio2">Financial Year wise Comparison</label>
                                </div>
                                <div class="flex w-full md:w-1/2 lg:w-1/3">
                                    <input class="form-check-input" type="radio" name="inlineRadioOptions" id="inlineRadio3" value="area" checked={status === "area"} />
                                    <label class="ml-2 text-base font-medium text-black" for="inlineRadio3">Area wise Comparison</label>
                                </div>
                            </div>

                            {status === "indicator" ?
                                <IndicatorCompare fyear={fyear}
                                    state={state}
                                    district={district}
                                    month={month}
                                    area={area}
                                    indicator={indicator}
                                    areaType={areaType}
                                    indicatorCategory={indicatorCategory}
                                    stateDropdown={stateDropdown}
                                    districtDropdown={districtDropdown}
                                    fyDropdown={fyDropdown}
                                    monthDropdown={monthDropdown}
                                    indicatorDropdown={indicatorDropdown}
                                    setAreaType={setAreaType}
                                    setIndicator={setIndicator}
                                    setArea={setArea}
                                    setMonth={setMonth}
                                    setFyear={setFyear}
                                    setState={setState}
                                    setDistrict={setDistrict}
                                    status={status}
                                    setbarChartData={setbarChartData}
                                    setLineChartData={setLineChartData}
                                    setTableData={setTableData}
                                    setQualityData={setQualityData}
                                    isSelected={isSelected}
                                    setIsSelected={setIsSelected}
                                    toggleValue={toggleValue}
                                    setFound={setFound}
                                /> : null}

                            {status === "area" ?
                                <AreaCompare fyear={fyear}
                                    state={state}
                                    district={district}
                                    month={month}
                                    area={area}
                                    indicator={indicator}
                                    areaType={areaType}
                                    indicatorCategory={indicatorCategory}
                                    stateDropdown={stateDropdown}
                                    districtDropdown={districtDropdown}
                                    fyDropdown={fyDropdown}
                                    indicatorDropdown={indicatorDropdown}
                                    setAreaType={setAreaType}
                                    setIndicator={setIndicator}
                                    setArea={setArea}
                                    setMonth={setMonth}
                                    setFyear={setFyear}
                                    setState={setState}
                                    setDistrict={setDistrict}
                                    level={level}
                                    setLevel={setLevel}
                                    status={status}
                                    setbarChartData={setbarChartData}
                                    setLineChartData={setLineChartData}
                                    setTableData={setTableData}
                                    setQualityData={setQualityData}
                                    isSelected={isSelected}
                                    setIsSelected={setIsSelected}
                                    toggleValue={toggleValue}
                                    setFound={setFound}
                                /> : null}

                            {status === "fy" ?
                                <FYCompare fyear={fyear}
                                    state={state}
                                    district={district}
                                    month={month}
                                    area={area}
                                    indicator={indicator}
                                    areaType={areaType}
                                    indicatorCategory={indicatorCategory}
                                    stateDropdown={stateDropdown}
                                    districtDropdown={districtDropdown}
                                    fyDropdown={fyDropdown}
                                    indicatorDropdown={indicatorDropdown}
                                    setAreaType={setAreaType}
                                    setIndicator={setIndicator}
                                    setArea={setArea}
                                    setMonth={setMonth}
                                    setFyear={setFyear}
                                    setState={setState}
                                    setDistrict={setDistrict}
                                    status={status}
                                    setbarChartData={setbarChartData}
                                    setLineChartData={setLineChartData}
                                    setTableData={setTableData}
                                    setQualityData={setQualityData}
                                    isSelected={isSelected}
                                    setIsSelected={setIsSelected}
                                    toggleValue={toggleValue}
                                    setFound={setFound}
                                /> : null}

                            <div class="flex my-2 md:my-0 md:px-1 items-center">
                                <div className='flex w-full lg:w-1/5 justify-center'>
                                    <div className='w-11/12'>
                                        {ToggleButtonSwitch}
                                    </div>
                                </div>
                            </div>

                            {(isSelected || indicator.length === 0 || fyear.length === 0 || area.length === 0) ? (
                                <section id='main_dashboard_container' className='flex flex-col'>

                                    <section
                                        id='indicator_compare'
                                        className='flex md:flex-wrap flex-wrap justify-center items-center'>

                                        {(fyear != 'All' && area < 39) ?
                                            (<div className='flex w-full flex-wrap'>
                                                <div className='flex w-full md:w-1/2 justify-center items-center'>
                                                    {(status === "indicator") ? ((found && lineChartData != null && lineChartData != '') ?
                                                        <IndicatorCompareLineChart
                                                            lChartData={lineChartData}
                                                            indicator={indicator}
                                                            fyear={fyear}
                                                            toggleValue={toggleValue}
                                                            indicatorDropdown={indicatorDropdown}
                                                        /> : <div className='flex text-xl font-bold text-black'>Data Not Available</div>)
                                                        : null}
                                                </div>
                                                <div className='flex w-full md:w-1/2 justify-center items-center'>
                                                    {(status === "indicator") ? ((found && barChartData != null && barChartData != '') ?
                                                        <IndicatorCompareBarChart
                                                            barChartData={barChartData}
                                                            indicator={indicator}
                                                            toggleValue={toggleValue}
                                                            indicatorDropdown={indicatorDropdown}
                                                        /> : <div className='flex text-xl font-bold text-black'>Data Not Available</div>)
                                                        : null}
                                                </div>
                                            </div>
                                            ) :
                                            <div className='flex w-full md:w-9/12 justify-center items-center'>
                                                {(status === "indicator") ? ((found && lineChartData != null && lineChartData != '') ?
                                                    <IndicatorCompareLineChart
                                                        lChartData={lineChartData}
                                                        indicator={indicator}
                                                        fyear={fyear}
                                                        toggleValue={toggleValue}
                                                        indicatorDropdown={indicatorDropdown}
                                                    /> : <div className='flex text-xl font-bold text-black'>Data Not Available</div>)
                                                    : null}
                                            </div>
                                        }
                                    </section>

                                    <section id='fy_area_compare'>
                                        <div className='flex w-full md:w-full justify-center items-center' >
                                            {(status === "area") ? ((found && lineChartData != null && lineChartData != '') ?
                                                <AreaCompareLineChart
                                                    lChartData={lineChartData}
                                                    area={area}
                                                    fyear={fyear}
                                                    toggleValue={toggleValue}
                                                /> : <div className='flex text-xl font-bold text-black'>Data Not Available</div>) : null}

                                            {(status === "fy") ? ((found && lineChartData != null && lineChartData != '') ?
                                                <FYCompareLineChart
                                                    lChartData={lineChartData}
                                                    fyear={fyear}
                                                    toggleValue={toggleValue}
                                                /> : <div className='flex text-xl font-bold text-black'>Data Not Available</div>) : null}
                                        </div>
                                    </section>
                                </section>
                            ) : (
                                SkeletonScreen
                            )}

                        </div>

                        <>
                            <Footer />
                        </>
                    </main>
                </div>
            </div>
        </React.Fragment>
    )

}